import React from 'react'
import {Pie} from 'react-chartjs-2'
import {Chart as ChartJS, ArcElement, Tooltip, Legend, Title} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels' // Import the plugin
import {useSelector} from 'react-redux'
import {useGetAdminVegicleGPSQuery} from '../../redux/network/AdminDashboardApi'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

// Register necessary Chart.js components and the datalabels plugin
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels)

const GPSPieChart = () => {
  const {startDate, endDate, customers, isFiltered} = useSelector(
    (state: any) => state.Filter.Filter
  )
  const {data: gpsData, error: gpsError} = useGetAdminVegicleGPSQuery(
    {startDate, endDate, customers},
    {refetchOnMountOrArgChange: true, pollingInterval: isFiltered ? 0 : 10000, skip: false}
  )

  const data = {
    type: 'pie',
    labels: ['WITH GPS', 'NO GPS'],
    datasets: [
      {
        label: 'Dataset 1',
        data: gpsData?.data ?? [],
        backgroundColor: ['rgba(33, 147, 176, 0.8)', 'rgba(236, 111, 102, 0.8)'],
      },
    ],
  }
  const total = data.datasets[0].data.reduce((acc: any, value: any) => acc + value, 0)
  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          padding: 15,
        },
      },
      tooltip: {
        enabled: true,
      },
      title: {
        display: true,
        text: 'GPS',
      },
      datalabels: {
        // Configure the data labels plugin
        color: '#fff',
        display: true,
        formatter: function (value: number) {
          const percentage = ((value / total) * 100) // Calculate percentage
          return `${percentage < 0.01 ? '< 0.01' : percentage.toFixed(2)}%` // Show the percentage values
        },
        font: {
          weight: 'bold',
          size: 14,
        },
        align: 'center',
        anchor: 'center',
      },
    },
  }

  const hasValidData =
    data.datasets[0].data &&
    data.datasets[0].data.length > 0 &&
    data.datasets[0].data.some((value: any) => value > 0)

  return (
    <div
      className='card mb-xl-8 w-100 card-xl-stretch'
      style={{
        border: '1px solid rgba(236, 111, 102, 0.1)',
      }}
    >
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark fs-2'>Vehicle GPS Availability</span>
          <span className='text-muted mt-1 fw-semibold fs-6'>GPS Availability Summary</span>
        </h3>
      </div>
      <div>
        {hasValidData ? (
          <div className='card-body pt-0 d-flex align-items-end' style={{height: '400px'}}>
            <Pie data={data} options={options} />
          </div>
        ) : (
          <div
            className='card-body pt-0 d-flex flex-column align-items-center justify-content-center'
            style={{height: '400px'}}
          >
            <img
              src={toAbsoluteUrl('/media/other/nodata.png')}
              alt='No data available'
              style={{width: 'auto', height: '70%', objectFit: 'contain', opacity: 0.7}}
            />
            <span className='text-muted fs-4'>No data for the selected option</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default GPSPieChart
